const PAY = 'PAY'

export { PAY };